<template>
  <div>
    <Head :title="title" />
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('First name')" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Last name')" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Email')" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Phone')" />
            <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('City')" />
          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Address')" />
          <select-input v-model="form.country_id" :error="form.errors.country_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Country')">
            <option :value="null" />
            <option v-for="c in countries" :key="c.id" :value="c.id">{{ __(c.name) }}</option>
          </select-input>
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/3" type="password" autocomplete="new-password" :label="__('Password')" />
          <select-input v-if="user.id !== auth.user.id" v-model="form.role_id" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Role')">
              <option :value="null" />
              <option v-for="c in roles" :key="c.id" :value="c.id">{{ __(c.name) }}</option>
          </select-input>

          <select-input v-model="form.department_id" :error="form.errors.department_id" :onChange="loadCategories" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Department')" :required="true">
                        <option :value="null" />
                        <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>
          
          <select-input v-model="form.category_id" :onChange="setDepCat" :error="form.errors.category_id" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Category')" :required="true">
                        <option :value="null" />
                        <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <div class="w-full lg:w-1/3 shadow p-8">
             <ul>
                <h3 class="font-bold mb-3">Responsable en :</h3>
                <li class="flex justify-between mb-2" v-for="ucd in user_cat_dep_list" :id="ucd.id">
                  <div class="w-auto">{{ ucd.name }}</div>
                  <div class="w-auto">
                    <button  type="button" class="btn text-red-700 flex justify-center items-center pb-3 border-0 pl-0" @click="remove(ucd.id)">
                      {{ __('Delete') }}
                    </button>
                  </div>
                </li>
            </ul>
           </div>

          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/3" type="file" accept="image/*" label="Photo" />
            <div class="w-full lg:w-1/3 flex items-center justify-start"><img v-if="user.photo_path" class="block mb-2 w-8 h-8 rounded-full" :src="user.photo_path" /></div>
          
         
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="user.id !== auth.user.id && user_access.user.delete && !user.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
            {{ __('Delete User') }} </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update User') }} </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    user: Object,
    auth: Object,
    countries: Array,
    roles: Array,
    cities: Array,
    title: String,
    categories : Array,
    departments : Array,
    user_cat_dep : Array,
    user_cat_dep_list: Array,
  },
  remember: 'form',
  data() {
    return {
        user_access: this.$page.props.auth.user.access,
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        phone: this.user.phone,
        city: this.user.city,
        address: this.user.address,
        country_id: this.user.country_id,
        password: '',
        role: this.user.role,
        role_id: this.user.role_id,
        photo: null,
        category_id: this.user.category_id,
        department_id  : this.user.department_id,
        user_cat_dep : this.user_cat_dep
      }),
    }
  },
  created() {
    // this.setDefaultValue(this.countries, 'country_id', 'United States')
  },
  methods: {
    setDefaultValue(arr, key, value){
      const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
      if(find){
        this.form[key] = find['id']
      }
    },
    update() {
      this.form.post(this.route('users.update', this.user.id), {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(route('users.destroy', this.user.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(route('users.restore', this.user.id))
      }
    },
    loadCategories(e){
      this.$inertia.get(this.route('users.edit', { user : this.user.id , category_id: e.target.value}), {e}, {
              preserveState: true,
              preserveScroll: true,
              replace: true
      })
    },
    remove(item){
      if (confirm('¿Esta seguro que desea borrar este registro?')) {
        for( var i = 0; i < this.form.user_cat_dep.length; i++){ 
            if ( this.form.user_cat_dep[i] == item) { 
              this.form.user_cat_dep.splice(i, 1); 
            }
        }
        this._reload();
      }
    },
     _reload(){
        this.$inertia.get(this.route('users.edit', {user : this.user.id , user_cat_dep: this.form.user_cat_dep , category_id: this.form.department_id}), {}, {
                preserveState: true,
                preserveScroll: true,
                replace: true
          })
     }, setDepCat(){
        this.form.user_cat_dep.push(this.form.department_id+''+this.form.category_id);
        this._reload();
    }
  },
}
</script>
